import { imgIsExist } from '@/utils'
import { isImage } from '@/utils/validate'

export default {
  inserted: async function (el, binding) {
    const { value } = binding
    const imgURL = Object.prototype.toString.call(value) === '[object String]' ? value : ''

    if (imgURL) {
      const exist = await imgIsExist(imgURL)
      if (exist) {
        el.setAttribute('src', imgURL)
        return
      }
    }

    if (isImage(el.src) || /^data:image/.test(el.src)) {
      const exist = await imgIsExist(el.src)
      if (exist) {
        el.setAttribute('src', el.src)
        return
      }
    }

    // 默认图完整路径 /jw_project_template/htmldev/PC/v0/public/img/common/noImg.png
    el.setAttribute('src', '/img/common/noImg.png')
  }
}
